import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicCaseInfoComponent } from './info/info.component';

const routes: Routes = [
    {
        path: 'public/case',
        children: [
            { path: ':token', component: PublicCaseInfoComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PublicCaseInfoRoutingModule { }
